//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'

//
import PurchaseOrderModel from '@/models/Purchase/PchPurchaseOrder'
import Translator from '@/services/translator'

//
import fields from './fields'

//
export default {
    name: 'purchase-order-reception',
    components: {
        ModelForm,
    },
    computed: {
        //
        ...mapState('AuthModule', ['user']),
        ...mapState('SnackbarModalModule', ['responseConfirm']),

        /**
         * @description
         * Fields props
         *
         * @return     {Object}  The field props params
         */
        fieldsProps() {
            return {
                g_branch_office_id: this.user.hr_employee.g_branch_office_id,
                is_service: this.formData.is_service,
            }
        },

        /**
         * @description
         * Form props
         *
         * @return     {Object}  The form props params
         */
        formProps() {
            return {
                editable: false,
                fields: fields(this.fieldsProps),
                loading: this.formBusy,
                switchEdit: this.$can('EXECUTE_RECEIVE_PURCHASE_ORDER'),
            }
        },
    },
    data() {
        return {
            formBusy: false,
            formData: {},
        }
    },
    methods: {

        //
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        async busy() {
            this.formBusy = !this.formBusy
        },

        /**
         *
         */
        fetch() {
            return PurchaseOrderModel.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
        },

        /**
         *
         */
        redirect() {
            this.$router.push({ name: 'purchase-order-list' })
        },

        /**
         *
         */
        reset() {
            this.busy()
                .then(this.fetch)
                .then(this.busy)
        },

        /**
         *
         */
        setFormData(model) {
            // set form data
            this.formData = model.reset()

            // initial warehouse from orderer warehouse id
            this.formData.wh_warehouse_reception_id = this.formData.wh_warehouse_reception_id || this.formData.wh_warehouse_id
        },

        /**
         * Shows the confirm close exceded.
         */
        showConfirmCloseExceded() {
            this.showWarningSnackbar({
                title: 'Cerrar orden de compra',
                message: '¿Confirma el cierre de la orden de compra con cantidades excedidas?',
                confirm: 'confirmar cierre',
            })
        },

        /**
         * Shows the confirm close partially exceded.
         */
        showConfirmClosePartiallyExceded() {
            this.showWarningSnackbar({
                title: 'Cerrar orden de compra',
                message: '¿Confirma el cierre parcial de la orden de compra con cantidades excedidas?',
                confirm: 'cierre parcial',
            })
        },

        /**
         * { function_description }
         *
         * @param      {<type>}  error   The error
         */
        error(error) {
            this.showErrorSnackbar(Translator(PurchaseOrderModel, error.response.data))
        },

        /**
         *
         */
        showSnackbar(type, title, message, callback) {
            this.initSnackbar(this.fillSnack(type, title, message))
            if (typeof callback === 'function') callback()
        },

        /**
         * { function_description }
         */
        successClose() {
            this.showSuccessSnackbar('Orden de compra recepcionada y cerrada.')
        },

        /**
         * { function_description }
         */
        successClosePartially() {
            this.showSuccessSnackbar('Orden de compra recepcionada parcialmente.')
        },

        /**
         * { function_description }
         *
         * @param      {<type>}  model   The model
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitClose() {

            //
            if (this.formData.has_exceded_reception) {
                return this.showConfirmCloseExceded()
            }

            //
            return this.toWait(true)
                .then(this.toClose)
                .then(this.toWait)
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitClosePartially() {

            //
            if (this.formData.has_exceded_reception) {
                return this.showConfirmClosePartiallyExceded()
            }

            //
            return this.toWait(true)
                .then(this.toClosePartially)
                .then(this.toWait)
        },

        /**
         * { function_description }
         *
         * @param      {<type>}  model   The model
         * @return     {<type>}  { description_of_the_return_value }
         */
        toClose(model) {
            return model
                .close()
                .attach(model.toClosingData())
                .then(this.successClose)
                .then(this.reset)
                .catch(this.error)
        },

        /**
         * Returns a close partially representation of the object.
         *
         * @return     {<type>}  Close partially representation of the object.
         */
        toClosePartially(model) {
            return model
                .close_partially()
                .attach(model.toClosingData())
                .then(this.successClosePartially)
                .then(this.reset)
                .catch(this.error)
        },

        /**
         * { function_description }
         *
         * @param      {<type>}  value   The value
         * @return     {<type>}  { description_of_the_return_value }
         */
        toWait(value) {
            return this.$refs.form.setWait(value)
        }
    },
    watch: {

        /**
         * { function_description }
         */
        responseConfirm(value) {
            switch (value) {
                case 'confirma cierre': return this.toWait(true).then(this.toClose).then(this.toWait)
                case 'cierre parcial': return this.toWait(true).then(this.toClosePartially).then(this.toWait)
            }
        },
    },
    beforeMount() {
        this.setTitle('Recepción de orden de compra')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_PURCHASE_ORDER')) ctx.$router.push('/')
        })
    },
    mounted() {
        this.reset()
    },
}
